import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useDropzone } from 'react-dropzone';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from "@material-ui/core/FormControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileUpload, faFileDownload } from '@fortawesome/free-solid-svg-icons'

// core components
import Table from 'components/Table/Table.js';
import EditTable from 'components/Table/EditTable.js';
import DndTable from 'components/Table/DndTable.js';
import Button from "components/CustomButtons/Button.js";
import GridItem from 'components/Grid/GridItem.js';

import styles from 'views/component/Styles.js';
import Confirm from 'views/component/Confirm.js';
import GridContainer from "components/Grid/GridContainer";

const useStyles = makeStyles(styles);

export default function Routing(props) {
    const { testcase, onTestcaseChange } = props;
    const classes = useStyles();

    const [productSelected, setProductSelected] = useState('');
    const [taskList, setTaskList] = useState({ taskList: [] });
    const [showDrop, setShowDrop] = useState(true);

    const [testcaseDataEdit, setTestcaseDataEdit] = useState({ ...testcase });
    const [taskListEdit, setTaskListEdit] = useState({ taskList: [] });

    const [editableTaskList, setEditableTaskList] = useState(false);
    const [reorderable, setReorderable] = useState(false);

    const [taskConfirmShow, showTaskConfirm] = useState(false);
    const [reorderConfirmShow, showReorderConfirm] = useState(false);

    const [checkSelects, setCheckSelects] = useState({ facility: [] });
    const noFacility = ['트랙', '분류', '워커', 'RGV'];

    useEffect(() => {
        updateTaskList();
        setTestcaseDataEdit({ ...JSON.parse(JSON.stringify(testcase)), removedProcessList: [] });
        setCheckSelects({
            facility: testcase.facilityList.filter(item => !noFacility.includes(item.modelType)).map(item => {
                return { name: item.name, value: item.facilityId };
            })
        });
    }, [testcase]);

    useEffect(() => {
        loadTaskList();
    }, [taskList, productSelected]);

    const updateTaskList = function () {
        axios.get('data/task/all/' + testcase.testcaseId)
            .then(response => {
                setTaskList({ taskList: response.data });
                setEditableTaskList(false);
                if (response.data.length !== 0) {
                    setShowDrop(false);
                }
            });
    }
    const loadTaskList = function () {
        let temp = [...JSON.parse(JSON.stringify(taskList.taskList))];
        temp = temp.filter(item => productSelected ? item.productName === productSelected : true);
        setTaskListEdit({ testcaseId: testcase.testcaseId, taskList: temp, removedTaskList: [] });
    }
    const clickTaskEditButton = function () {
        loadTaskList();
        setEditableTaskList(true);
    };
    const clickReorderButton = function () {
        loadTaskList();
        setReorderable(true);
    };
    const validateTask = function () {
        const validated = taskListEdit.taskList.reduce((prev, item) => (prev && parseFloat(item.reqTimeMean)), true);
        if (validated){
            showTaskConfirm(true);
        } else {
            alert('소요시간 평균은 0이 아니어야 합니다')
        }
    }
    const onTaskConfirm = function (result) {
        if (result) {
            const orderedData = setPrevTask(taskListEdit.taskList);
            axios.post('data/task/listedit',
                { ...taskListEdit, taskList: orderedData.filter(task => task.updated) })
                .then(response => {
                    onTestcaseChange();
                    setEditableTaskList(false);
                });
        }
        showTaskConfirm(false);
    };
    const clickTaskAddButton = function () {
        let tempData = { ...taskListEdit };
        tempData.taskList.push({
            name: "", nextName: "", facility: [], nextTask: "", prevName: "", prevTask: "",
            productName: '', setupTime: '', reqTimeDev: '0', reqTimeMean: '10', updated: true
        });
        setTaskListEdit(tempData);
    };
    const onTaskChange = function (row, col, value) {
        let tempData = { ...taskListEdit };
        tempData.taskList[row][col] = value;
        tempData.taskList[row].updated = true;
        setTaskListEdit(tempData);
    };
    const onTaskRemove = function (row) {
        let tempData = { ...taskListEdit };
        let removedTask = tempData.taskList.splice(row, 1);
        tempData.removedTaskList = [...tempData.removedTaskList, removedTask[0]];
        setTaskListEdit(tempData);
    };

    const onReorderConfirm = function (result) {
        if (result) {
            axios.post('data/task/listedit', { ...taskListEdit, taskList: taskListEdit.taskList })
                .then(response => {
                    onTestcaseChange();
                    setReorderable(false);
                });
        }
        showReorderConfirm(false);
    };
    const onReorderData = function (data, removed) {
        setTaskListEdit({ ...taskListEdit, taskList: setPrevTask(data), removedTaskList: (removed ? removed : taskListEdit.removedTaskList) });
    };

    const setPrevTask = function (data) {
        let reorderData = data;
        let ordr = 0;
        reorderData.forEach((item) => {
            let index = data.indexOf(item);
            let prevName = item.prevName;
            if (index !== 0 && item.productName === data[index - 1].productName) {
                prevName = data[index - 1].name;
                if (item.prevName !== prevName) {
                    item.prevName = prevName;
                    item.updated = true;
                }
                if (item.ordr != ordr) {
                    item.ordr = ordr;
                    item.updated = true;
                }
                ordr++;
            } else {
                ordr = 0;
                if (item.ordr != ordr) {
                    item.ordr = ordr;
                    item.updated = true;
                }
                ordr++;
            }
        });
        return reorderData;
    }
    // 파일 드롭구역
    const onDrop = function (acceptedFiles) {
        acceptedFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = () => {
                let temp = [];
                reader.result.match(/[^\r\n]+/g).forEach((line, index) => {
                    if (index !== 0) {
                        let tokens = line.split(',').map(token => token.trim());
                        if (!testcaseDataEdit.processList.find(item => item.productName === tokens[0])) {
                            let temp2 = { ...testcaseDataEdit };
                            temp2.processList.push({ productName: tokens[0], updated: true });
                            setTestcaseDataEdit(temp2);
                        }
                        const facility = tokens[2].split('+').map(item => checkSelects.facility.find(fac => fac.name === item.trim())?.value)
                            .filter(item => !!item);
                        if (tokens[4] === "0") tokens[4] = "";
                        temp.push({
                            productName: tokens[0], name: tokens[1], facility: facility, setupTime: tokens[3],
                            reqTimeMean: tokens[4], reqTimeDev: tokens[5], updated: true
                        });
                    }
                });
                const removed = taskListEdit.taskList.filter(item => item.taskId);
                onReorderData(temp, removed);
                if (temp.length !== 0) {
                    setShowDrop(false);
                    setEditableTaskList(true);
                }
            }
            reader.readAsText(file, 'euc-kr');
        });
    };

    const onDropRejected = useCallback(() => {
        alert('CSV 파일만 입력 가능합니다');
    }, []);

    const cancelUpload = function (e) {
        e.stopPropagation();
        setShowDrop(false);
    };

    const createDownloadUrl = function (fileName) {
        let base = (axios.defaults.baseURL ? axios.defaults.baseURL : "/GiGAtwinFactory") + "/data/download/";
        return base + testcase.testcaseId + fileName;
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, accept: '.csv' });

    const getProductSelect = function () {
        return <FormControl fullWidth className={classes.selectFormControlInfo}>
            <InputLabel htmlFor="productSelect" className={classes.selectLabel}>상품명</InputLabel>
            <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
                value={productSelected} onChange={e => { setProductSelected(e.target.value) }} inputProps={{ id: "productSelect" }}>
                <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
                    value='' key={-1}>
                    전체
                </MenuItem>
                {[...new Set(taskList.taskList.map(item => item.productName))].map(productName => {
                    return <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
                        value={productName} key={productName}>
                        {productName}
                    </MenuItem>;
                })}
            </Select>
        </FormControl>;
    }
    return (<>
        <div className={classes.cellContentModel}>
            {showDrop ?
                <div {...getRootProps({ className: 'dropzone' })} className={classes.dropzone}>
                    <input {...getInputProps()} />
                    <div className={classes.dropzoneText}>
                        <div>파일을 드래그하여 업로드하거나<br /> 직접 입력해주세요</div>
                        <Button color="info" onClick={e => cancelUpload(e)}>직접입력</Button>
                    </div>
                </div>
                : <>
                    {editableTaskList ? <GridContainer>
                        <GridItem md={2} xs={12}>
                            {getProductSelect()}
                        </GridItem>
                        <GridItem md={10} xs={12}>
                            <Confirm show={taskConfirmShow} title="수정 사항 저장" text="수정된 공정 목록을 저장합니다."
                                onConfirm={onTaskConfirm} confirmText="저장" type='info' />
                            <Button color="danger" className={classes.right} size="sm" onClick={e => { loadTaskList(); setEditableTaskList(false); }}>취소</Button>
                            <Button color="info" className={classes.right} size="sm" onClick={e => { validateTask() }}>저장</Button>
                            <Button color="infoOutline" className={classes.right} size="sm" onClick={clickTaskAddButton}>추가</Button>
                        </GridItem>
                        <GridItem md={12}>
                            <EditTable tableHeaderColor="primary"
                                tableHead={["제품명", "공정명", "설비명", "셋업 시간(초)", "소요 시간 평균(초)", "소요 시간 분산"]}
                                tableCols={["productName", "name", "facility", "setupTime", "reqTimeMean", "reqTimeDev"]}
                                tableData={taskListEdit.taskList}
                                underlineColor="info"
                                onChange={onTaskChange}
                                onRemove={onTaskRemove}
                                checkSelects={checkSelects}
                                required={['reqTimeMean']}
                                types={{ 'setupTime': 'number', 'reqTimeMean': 'number', 'reqTimeDev': 'number' }}
                            />
                        </GridItem>
                    </GridContainer> : <>
                        {reorderable ? <GridContainer>
                            <GridItem md={2} xs={12}>
                                {getProductSelect()}
                            </GridItem>
                            <GridItem md={10} xs={12}>
                                <Confirm show={reorderConfirmShow} title="수정 사항 저장" text="수정된 공정 목록을 저장합니다."
                                    onConfirm={onReorderConfirm} confirmText="저장" type='info' />
                                <Button color="danger" className={classes.right} size="sm"
                                    onClick={e => { loadTaskList(); setReorderable(false); }}>취소</Button>
                                <Button color="info" className={classes.right} size="sm"
                                    onClick={e => { showReorderConfirm(true); }}>순서 저장</Button>
                            </GridItem>
                            <GridItem md={12}>
                                <DndTable tableHeaderColor="primary"
                                    tableHead={["제품명", "공정명", "설비명", "셋업 시간(초)", "소요 시간 평균(초)", "소요 시간 분산"]}
                                    tableCols={["productName", "name", "facilityNames", "setupTime", "reqTimeMean", "reqTimeDev"]}
                                    tableData={taskListEdit.taskList}
                                    onChange={onReorderData}
                                />
                            </GridItem>
                        </GridContainer> : <GridContainer>
                            <GridItem md={2} xs={12}>
                                {getProductSelect()}
                            </GridItem>
                            <GridItem md={10} xs={12}>
                                <a download href={createDownloadUrl("/routing.csv")}>
                                    <Button justIcon color="infoOutline" className={classes.right} size="sm">
                                        <FontAwesomeIcon icon={faFileDownload} />
                                    </Button>
                                </a>
                                <Button justIcon color="infoOutline" className={classes.right} size="sm" onClick={e => { setShowDrop(true); }}>
                                    <FontAwesomeIcon icon={faFileUpload} />
                                </Button>
                                <Button color="infoOutline" className={classes.right} size="sm" onClick={clickTaskEditButton}>공정 수정</Button>
                                {taskListEdit.taskList.length === 0 ? null :
                                    <Button color="info" className={classes.right} size="sm" onClick={clickReorderButton}>순서 변경</Button>}
                            </GridItem>
                            <GridItem md={12}>
                                <Table tableHeaderColor="primary"
                                    tableHead={["제품명", "공정명", "설비명", "셋업 시간(초)", "소요 시간 평균(초)", "소요 시간 분산"]}
                                    tableCols={["productName", "name", "facilityNames", "setupTime", "reqTimeMean", "reqTimeDev"]}
                                    tableData={taskListEdit.taskList}
                                />
                            </GridItem>
                        </GridContainer>}
                    </>}
                </>}
        </div>
    </>);
}
Routing.propTypes = {
    testcase: PropTypes.any
};